export default __webpack_public_path__ + "static/media/EventReg-Wedding.467b7399.svg";